/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';

import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function UserMultiSelectWidget(props) {
  const { id, required, schema, value = [], onChange, rawErrors, options } = props;

  const [values, setValue] = useState(value);

  const handleChange = (event, newValue = []) => {
    setValue(newValue);
  };

  useEffect(() => {
    //in the parent use eval() function to convert to array
    onChange(values.length ? JSON.stringify(values) : '');
  }, [values]);

  return (
    <Autocomplete
      id={id}
      multiple
      freeSolo
      fullWidth
      options={[]}
      value={values}
      inputMode="text"
      name={schema.title}
      onChange={handleChange}
      disabled={schema.disabled}
      renderTags={(value, getTagProps) =>
        eval(value).map((option, index) => <Chip variant="outlined" label={option} {...getTagProps({ index })} />)
      }
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          required={required}
          label={schema.title}
          error={!!(rawErrors && rawErrors.length)}
        />
      )}
    />
  );
}
